import type { FC } from 'react';

import { useFormatter } from '@eneco/i18n';
import { Stack, Heading, Text } from '@eneco/sparky';

interface Props {
  label: string;
  value?: number;
}

export const SingleAmount: FC<Props> = ({ label, value }) => {
  const { currency } = useFormatter();
  return (
    <Stack gap="3">
      <Text size="BodyM" weight="bold">
        {label}
      </Text>

      {value && (
        <Heading as="h2" size="M">
          {currency.euro(Math.abs(value))}
        </Heading>
      )}
    </Stack>
  );
};
